import { configureStore } from '@reduxjs/toolkit';

import appReducer from './store/app';
import authReducer from './store/auth';
import clubReducer from './store/club';
import commonReducer from './store/common';
import memberReducer from './store/member';
import walletReducer from './store/wallet';
import CountryReducer from './store/country';
// eslint-disable-next-line import/no-named-as-default
import campaignSlice from './store/campaign';
import reportsReducer from './store/reports';
import cronJobReducer from './store/cronJobs';
import settingsReducer from './store/settings';
// eslint-disable-next-line import/no-named-as-default
import analyticsSlice from './store/analytics';
import dashboardReducer from './store/dashboard';
import AdManagerReducer from './store/adManager';
import memberClubReducer from './store/memberClub';
import automationReducer from './store/automation';
import walletAddressReducer from './store/walletAddress';
// eslint-disable-next-line import/no-named-as-default
import dropDownListReducerSlicer from './store/dropDownLists';
import advertiserAccountReducer from './store/advertisingAccount';

export default configureStore({
  reducer: {
    common: commonReducer,
    auth: authReducer,
    app: appReducer,
    dashboard: dashboardReducer,
    country: CountryReducer,
    member: memberReducer,
    memberClub: memberClubReducer,
    club: clubReducer,
    settings: settingsReducer,
    analytics: analyticsSlice,
    campaigns: campaignSlice,
    wallet: walletReducer,
    dropDownLists: dropDownListReducerSlicer,
    walletAddress: walletAddressReducer,
    advertiser: advertiserAccountReducer,
    adManager: AdManagerReducer,
    cronJob: cronJobReducer,
    report: reportsReducer,
    automation: automationReducer,
  },
});
